import { useEffect, useState } from "react";
import { useRef } from "react";
import SearchBar from "../SearchFilter";
import DataTabs from "./DataTabs";
import NoRecordsCard from "../NoRecordsCard";
import IconOpenEye from "../SvgIcon/IconOpenEye";
import UserFilter from "./UserFilter";
import { useAuth } from "../../services/AuthContext";
import api from "../../services";
import CustomerCard from "./customer-card";
import MapViewNew from "./MapViewNew";
import "./style.css";
import { getLocalDate } from "../../services/getLocalDate";
import UpcomingCustomer from "./UpcomingCustomer";
import getNoDataProps from "./getNoDataProps";
import socket from "../../services/socket";
const TRACKING_CONFIG = require('../../config/trackingConfig');


export default function UsersCardsNewMap() {
  const selectedUserRef = useRef(null);
  const [activeTab, setActiveTab] = useState("today");
  const [fadeKey, setFadeKey] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [loading, setLoading] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedPath, setSelectedPath] = useState([]);
  const { userType, country } = useAuth();
  const [cardKey, setCardKey] = useState(0);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [fullTimeline, setFullTimeline] = useState([]);
  const [uservisible, setuserVisible] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [manualLocationSelected, setManualLocationSelected] = useState(false);
  const [liveUsers, setLiveUsers] = useState({});
  const [selectedCustomerPos, setSelectedCustomerPos] = useState(null);

  // console.log("Country country", fullTimeline);
  // ✅ NEW: all upcoming scheduled data across all users
  const [upcomingData, setUpcomingData] = useState([]);
  const [upcomingLoading, setUpcomingLoading] = useState(false);
  
  useEffect(() => {
    selectedUserRef.current = selectedUser;
  }, [selectedUser]);
  
  // Code for real-time updates via socket
  useEffect(() => {
    // ✅ Join admin room
    socket.emit("joinAdmin");

    socket.on("userStatusUpdate", (data) => {
      console.log("STATUS UPDATE RECEIVED:", data);

      setLiveUsers(prev => ({
        ...prev,
        [data.userId]: {
          lat: data.lat,
          lng: data.lng,
          isIdle: data.status === "IDLE",
          status: data.status,
          lastUpdate: data.time
        }
      }));

      if (selectedUserRef.current?.User_Id === data.userId) {
        setSelectedPath(prev => {
          const last = prev[prev.length - 1];

          if (
            last &&
            Math.abs(last.Latitude - Number(data.lat)) < 0.00001 &&
            Math.abs(last.Longitude - Number(data.lng)) < 0.00001
          ) {
            return prev;
          }

          return [
            ...prev,
            {
              Latitude: Number(data.lat),
              Longitude: Number(data.lng),
              captured_Date: data.time
            }
          ];
        });
      }
    });


    // ✅ Listen for idle
    socket.on("userIdle", (data) => {
      updateUser(data, true);
    });

    // ✅ Listen for active
    socket.on("userActive", (data) => {
      updateUser(data, false);
    });

    return () => {
      socket.off("userIdle");
      socket.off("userActive");
    };
  }, []);

  const updateUser = (data, isIdle) => {
    setLiveUsers(prev => ({
      ...prev,
      [data.userId]: {
        lat: data.lat,
        lng: data.lng,
        isIdle,
        lastUpdate: data.time
      }
    }));
  };
  // Code for real-time updates via socket

  // ─── fetch check-in/out list once ────────────────────────────────────────
  useEffect(() => {
    const fetchVisits = async () => {
      setLoading(true);
      try {
        const response = await api.post("/getUserCheckinCheckoutList", { userType: userType, country: country });
        // console.log("Country", country, "Check-in/out response:", response);
        setuserVisible(response.data);
      } catch (error) {
        console.error("Get visits:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchVisits();
  }, []);

  // ─── set dateRange when tab changes ──────────────────────────────────────
  useEffect(() => {
    const today = new Date();
    if (activeTab === "today") {
      setDateRange({ start: getLocalDate(today), end: getLocalDate(today) });
    }
    if (activeTab === "previous") {
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      setDateRange({ start: getLocalDate(yesterday), end: getLocalDate(yesterday) });
    }
    if (activeTab === "upcoming") {
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      setDateRange({ start: getLocalDate(tomorrow), end: getLocalDate(tomorrow) });
    }
  }, [activeTab]);

  // ─── NEW: fetch ALL users' upcoming scheduled data when upcoming tab opens ─
  useEffect(() => {
    if (activeTab !== "upcoming") return;

    const fetchAllUpcoming = async () => {
      setUpcomingLoading(true);
      try {
        // get unique users from uservisible
        const uniqueUserIds = [...new Set(uservisible.map(u => u.User_Id))];

        // fetch all users' tracks in parallel
        const results = await Promise.all(
          uniqueUserIds.map(userId =>
            api.post("/getNewUserTrack", {
              User_Id: userId,
              datetype: "upcoming",
            }).then(res => ({
              userId,
              userName: uservisible.find(u => u.User_Id === userId)?.UserName || "",
              data: res.data,
            })).catch(() => ({ userId, userName: "", data: {} }))
          )
        );
        console.log("getNewUserTrack Upcoming", data);
        // console.log("All upcoming fetch results:", results);
        // collect all SCHEDULED items from all users
        const allScheduled = [];
        results.forEach(({ userName, data }) => {
          const timeline = data.timeline || [];
          const scheduled = timeline.filter(item => item.type === "SCHEDULED");
          scheduled.forEach(item => {
            allScheduled.push({
              ...item,
              UserName: item.UserName || userName, // ✅ attach UserName
              CurrentLocation: item.CurrentLocation || "",
            });
          });
        });
        // console.log("all upcoming:", allScheduled);
        setUpcomingData(allScheduled);
      } catch (error) {
        console.error("fetchAllUpcoming error:", error);
        setUpcomingData([]);
      } finally {
        setUpcomingLoading(false);
      }
    };

    fetchAllUpcoming();
  }, [activeTab, uservisible]);

  // ─── fetch tracks per user on click (today/previous only) ────────────────
  useEffect(() => {
    if (!selectedUser?.User_Id) return;
    if (activeTab === "upcoming") return; // ✅ skip for upcoming

    const datetypeMap = {
      today: "today",
      previous: "past",
    };

    const fetchTracks = async () => {
      try {
        // const payload = {
        //   User_Id: selectedUser.User_Id,
        //   datetype: datetypeMap[activeTab] || "today",
        // };
        let payload = {
          User_Id: selectedUser.User_Id,
          datetype: datetypeMap[activeTab] || "today",
        };

        // ✅ Override for previous tab with selected date
        if (activeTab === "previous" && dateRange.start) {
          payload = {
            User_Id: selectedUser.User_Id,
            datetype: "date",
            From_Date: dateRange.start,
            To_Date: dateRange.end,
          };
        }

        // console.log("User_Id", payload);

        const response = await api.post("/getNewUserTrack", payload);
        const timeline = response.data.timeline || [];
        console.log("getNewUserTrack Today and Previous", response.data);
        

        setFullTimeline(timeline);
        const visits = timeline.filter(item => item.type === "VISIT");
        const scheduled = timeline.filter(item => item.type === "SCHEDULED");

        if (activeTab === "today") {
          setLocationData([...visits, ...scheduled]);
        } else if (activeTab === "previous") {
          setLocationData(visits);
        }

        const trackOnly = timeline
          .filter(item =>
            item.type === "TRACK" &&
            Number(item.latitude) !== 0 &&
            Number(item.longitude) !== 0
          )
          .sort((a, b) => new Date(a.recorded_at) - new Date(b.recorded_at));

          console.log("TRACK Today and Previous", trackOnly);

        const deduped = trackOnly.filter((item, index, arr) => {
          if (index === 0) return true;
          const prev = arr[index - 1];
          return (
            Math.abs(prev.latitude - item.latitude) +
            Math.abs(prev.longitude - item.longitude) > 0.00001
          );
        });
        // const deduped = trackOnly;
        console.log("DUPLICATE REMOVED PATH:", deduped);
        setSelectedPath(
          deduped.map(item => ({
            Latitude: Number(item.latitude),
            Longitude: Number(item.longitude),
            captured_Date: item.recorded_at,
          }))
        );
        const finalPath = deduped.map(item => ({
          id: item.id,
          accuracy: item.accuracy,
          speed: item.speed,
          strategy:item.strategy,
          Latitude: Number(item.latitude),
          Longitude: Number(item.longitude),
          captured_Date: item.recorded_at ,
          created_at: item.created_at ,
        }));

        console.log("TRACK PATH:", finalPath);

        setSelectedPath(finalPath);
      } catch (error) {
        console.error("fetchTracks error:", error);
        setLocationData([]);
        setFullTimeline([]);
        setSelectedPath([]);
      }
    };

    fetchTracks();
  }, [selectedUser, activeTab, dateRange]);

  // ─── tab change handler ───────────────────────────────────────────────────
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setFadeKey((prev) => prev + 1);
    setCardKey((prev) => prev + 1);
    setSearchQuery("");
    setSelectedCustomerId(null);
    setSelectedUser(null);
    setShowDetails(false);
    setSelectedPath([]);
    setLocationData([]);
    setFullTimeline([]);
    setManualLocationSelected(false);
    setUpcomingData([]);
    setSelectedCustomerPos(null);
    if (tab === "today") {
      setDateRange({ start: null, end: null });
    }
  };

  const handleDateFilter = (startDate, endDate) => {
    setDateRange({
      start: startDate ? getLocalDate(startDate) : null,
      end: endDate ? getLocalDate(endDate) : null,
    });
    setSelectedCustomerId(null);
  };

  // ─── filtering logic ──────────────────────────────────────────────────────
  const filteredData = () => {
    let filtered = uservisible;

    const todayObj = new Date();
    todayObj.setHours(0, 0, 0, 0);
    const tomorrowObj = new Date(todayObj);
    tomorrowObj.setDate(todayObj.getDate() + 1);

    filtered = filtered.filter((u) => {
      const d = new Date(u.captured_Date);
      if (activeTab === "today") return d >= todayObj && d < tomorrowObj;
      if (activeTab === "previous") return d < todayObj;
      if (activeTab === "upcoming") return d >= tomorrowObj;
      return true;
    });

    if (searchQuery) {
      const lower = searchQuery.toLowerCase();
      filtered = filtered.filter((u) => {
        const nameMatch = (u?.UserName ?? "").toLowerCase().includes(lower);
        const dateMatch = u?.captured_Date
          ? new Date(u.captured_Date).toLocaleDateString().toLowerCase().includes(lower)
          : false;
        const timeMatch = u?.captured_Date
          ? new Date(u.captured_Date).toLocaleTimeString().toLowerCase().includes(lower)
          : false;
        return nameMatch || dateMatch || timeMatch;
      });
    }
    if (activeTab === "today" && dateRange.start && dateRange.end) {
      const start = new Date(dateRange.start);
      start.setHours(0, 0, 0, 0);
      const end = new Date(dateRange.end);
      end.setHours(23, 59, 59, 999);
      filtered = filtered.filter((u) => {
        const d = new Date(u.captured_Date);
        return d >= start && d <= end;
      });
    }
    if (activeTab === "previous" && dateRange.start && dateRange.end) {
      const todayObj2 = new Date();
      todayObj2.setHours(0, 0, 0, 0);
      const defaultYesterday = new Date(todayObj2);
      defaultYesterday.setDate(todayObj2.getDate() - 1);

      const isDefault =
        dateRange.start === getLocalDate(defaultYesterday) &&
        dateRange.end === getLocalDate(defaultYesterday);

      if (!isDefault) {
        // user picked a custom range — apply it
        const start = new Date(dateRange.start);
        start.setHours(0, 0, 0, 0);
        const end = new Date(dateRange.end);
        end.setHours(23, 59, 59, 999);
        filtered = filtered.filter((u) => {
          const d = new Date(u.captured_Date);
          return d >= start && d <= end;
        });
      }
    }

    return filtered;
  };

  const handleClearFilters = () => {
    setSearchQuery("");
    const today = new Date();
    if (activeTab === "today") {
      setDateRange({ start: getLocalDate(today), end: getLocalDate(today) });
    } else if (activeTab === "previous") {
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      setDateRange({ start: getLocalDate(yesterday), end: getLocalDate(yesterday) });
    } else if (activeTab === "upcoming") {
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      setDateRange({ start: getLocalDate(tomorrow), end: getLocalDate(tomorrow) });
    }
  };

  const data = filteredData();

  const uniqueUsers = Object.values(
    data.reduce((acc, user) => {
      if (!acc[user.User_Id]) acc[user.User_Id] = user;
      return acc;
    }, {})
  );

  // ─── auto-select from search ──────────────────────────────────────────────
  useEffect(() => {
    if (!searchQuery) { setSelectedCustomerId(null); return; }
    const lower = searchQuery.toLowerCase();
    const matched = data.find(v =>
      (v?.UserName ?? "").toLowerCase().includes(lower)
    );
    if (!matched) { setSelectedCustomerId(null); return; }
    setSelectedCustomerId(matched.id || matched.User_Id);
    const user = uservisible.find(u => u.User_Id === matched.User_Id);
    if (user) { setSelectedUser(user); setShowDetails(true); }
  }, [searchQuery, data]);

  // ─── customer card click → draw that day's track ──────────────────────────
  const handleSelectLocation = (item) => {
    // ✅ ADD THIS — capture customer position for highlight marker
    const lat = Number(item.Latitude);
    const lng = Number(item.Longitude);
    if (!isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
      setSelectedCustomerPos({
        lat,
        lng,
        name: item.CustomerName || "Visit",
        time: item.captured_Date
          ? new Date(item.captured_Date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
          : "",
        address: item.Address || "",
      });
    } else {
      setSelectedCustomerPos(null);
    }

    // ✅ your existing track drawing logic below — unchanged
    const visitDate = new Date(item.captured_Date).toISOString().split("T")[0];
    const dayTracks = fullTimeline
      .filter(t =>
        t.type === "TRACK" &&
        Number(t.Latitude) !== 0 &&
        Number(t.Longitude) !== 0 &&
        !isNaN(Number(t.Latitude)) &&
        !isNaN(Number(t.Longitude)) &&
        new Date(t.captured_Date).toISOString().split("T")[0] === visitDate
      )
      .sort((a, b) => new Date(a.captured_Date) - new Date(b.captured_Date));

    const deduped = dayTracks.filter((pt, index, arr) => {
      if (index === 0) return true;
      const prev = arr[index - 1];
      return (
        Math.abs(Number(prev.Latitude) - Number(pt.Latitude)) +
        Math.abs(Number(prev.Longitude) - Number(pt.Longitude)) >= 0.00001
      );
    });

    if (deduped.length > 0) {
      setManualLocationSelected(true);
      setSelectedPath(
        deduped.map(t => ({
          Latitude: Number(t.Latitude),
          Longitude: Number(t.Longitude),
          captured_Date: t.captured_Date,
        }))
      );
    }
  };
  
  const filteredUpcoming = upcomingData.filter(item => {
    const lower = searchQuery.toLowerCase();

    return (
      (item.CustomerName ?? "").toLowerCase().includes(lower) ||
      (item.UserName ?? "").toLowerCase().includes(lower) ||
      (item.Address ?? "").toLowerCase().includes(lower) ||
      (item.captured_Date
        ? new Date(item.captured_Date).toLocaleDateString().toLowerCase().includes(lower)
        : false),
      ( item.CurrentLocation ?? "").toLowerCase().includes(lower)
    );
  });
  // console.log("filtered upcoming:", filteredUpcoming);

  // const getUserStatus = (user) => {
  //   const live = liveUsers[user.User_Id];

  //   const isCheckedIn =
  //     user.StatusText === "CHECK_IN" ||
  //     user.status === 0 ||
  //     user.CheckInTime;

  //   // 1. BUSY
  //   if (user.isOnVisit) return "busy";

  //   // 2. NOT CHECKED IN
  //   if (!isCheckedIn) return "not_checked_in";

  //   // 🔥 3. TRUST BACKEND FIRST
  //   if (user.liveStatus) {
  //     return user.liveStatus.toLowerCase();
  //   }

  //   // 🔻 fallback only if backend missing
  //   if (!live || !live.lastUpdate) return "unreachable";

  //   const lastSeenTime = new Date(live.lastUpdate).getTime();
  //   if (isNaN(lastSeenTime)) return "unreachable";

  //   const lastSeenDiff = Date.now() - lastSeenTime;

  //   if (lastSeenDiff > TRACKING_CONFIG.UNREACHABLE_TIMEOUT_MS) {
  //     return "unreachable";
  //   }

  //   if (live.isIdle) return "idle";

  //   return "moving";
  // };

  const getUserStatus = (user) => {
    const live = liveUsers[user.User_Id];

    const isCheckedIn =
      user.StatusText === "CHECK_IN" ||
      user.status === 0 ||
      user.CheckInTime;

    // 1. BUSY
    if (user.isOnVisit) return "busy";

    // 2. NOT CHECKED IN
    if (!isCheckedIn) return "not_checked_in";

    // 🔥 3. LIVE SOCKET DATA FIRST (MOST IMPORTANT)
    if (live && live.status) {
      return live.status.toLowerCase();
    }

    // 🔻 4. FALLBACK → BACKEND STATUS
    if (user.liveStatus) {
      return user.liveStatus.toLowerCase();
    }

    // 🔻 5. FINAL FALLBACK
    return "unreachable";
  };
  // ─── render ───────────────────────────────────────────────────────────────
  // const selectedUserCheckin = selectedUser
  //   ? uservisible.find(u => u.User_Id === selectedUser.User_Id)
  //   : null;
  // console.log("checkinPoint data:", selectedUserCheckin);
  return (
    <section className="userrepoerts relative overflow-hidden">

      <div className="user-section">
        <div className="filterarea d-flex justify-content-between align-items-center mb-0">
          <div className="tab-nav-wrapper d-flex align-items-center gap-3">
            <h3>User Wise Report</h3>
            <div className="tab-nav d-flex position-relative">
              {DataTabs.map((tab) => (
                <button
                  key={tab.value}
                  className={`tab-btn ${activeTab === tab.value ? "active" : ""}`}
                  onClick={() => handleTabChange(tab.value)}
                >
                  {tab.label}
                </button>
              ))}
              <span className={`tab-indicator ${activeTab}`} />
            </div>
          </div>

          <div className="search d-flex justify-content-center justify-content-xl-end">
            <SearchBar
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              onClear={handleClearFilters}
            />
            {activeTab !== "today" && (
              <UserFilter onDateFilter={handleDateFilter} activeTab={activeTab} />
            )}
          </div>
        </div>
      </div>

      <div
        className={`d-flex colomview ${activeTab === "upcoming" ? "upcoming-tab" : ""} ${activeTab === "previous" ? "previous-tab" : ""} ${data.length === 0 && (searchQuery || (dateRange.start && dateRange.end))
          ? "datafilter" : ""}`}
      >
        {loading || upcomingLoading ? (
          <div className="full-screen-loader rounded">
            <div className="loader-box text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="m-0">Loading Details...</p>
            </div>
          </div>

        ) : activeTab === "upcoming" ? (

          // ════════════════════════════════════════════════════
          // ── UPCOMING TAB: show all scheduled directly ──
          // ════════════════════════════════════════════════════
          filteredUpcoming.length > 0 ? (
            <UpcomingCustomer
              key={cardKey}
              userData={filteredUpcoming}
              searchQuery={searchQuery}
            />
          ) : (
            <NoRecordsCard {...getNoDataProps(activeTab, searchQuery)} />
          )
        ) : (

          // ════════════════════════════════════════════════════
          // ,
          // ) : (── TODAY / PREVIOUS TAB ──
          // ════════════════════════════════════════════════════
          <>
            {uniqueUsers.length > 0 ? (
              <div key={fadeKey} className="home-table">
                <h6>
                  Users {activeTab === "today" && <span>Live</span>}
                </h6>
                <ul className="user-rows">
                  {uniqueUsers.map((user, index) => (
                    <li
                      key={user.id}
                      className={selectedUser?.User_Id === user.User_Id ? "active" : ""}
                      onClick={() => {
                        if (selectedUser?.User_Id === user.User_Id) {
                          setSelectedUser(null);
                          setShowDetails(false);
                          setManualLocationSelected(false);
                          setCardKey((prev) => prev + 1);
                        } else {
                          setSelectedUser(user);
                          setShowDetails(true);
                          setManualLocationSelected(false);
                          setCardKey((prev) => prev + 1);
                        }
                      }}
                    >
                      {/* ✅ STATUS DOT */}
                      <div className="indexnumber">{index + 1}</div>
                      <div className="user-status">
                        <p>{user.UserName} <span>{getUserStatus(user)}</span></p>
                        <div
                          className={`status-dot ${getUserStatus(user)}`}
                        />
                      </div>
                      {/* <div className="eyeiconshow"><IconOpenEye /></div> */}
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <NoRecordsCard {...getNoDataProps(activeTab, searchQuery)} />
            )}

            {data.length > 0 && (
              <div className={`map-wrapper ${showDetails ? "smallmap" : ""}`}>
                <div className="customerdetails">
                  <div className="locationmap">
                    {/* <MapView
                      pathLocations={
                        !showDetails
                          ? []
                          : activeTab === "today"
                            ? selectedPath
                            // : activeTab === "previous" && manualLocationSelected
                            //   ? selectedPath
                            //   : []
                            : activeTab === "previous"
                              ? selectedPath   // ✅ remove manualLocationSelected condition
                              : []
                      }
                      timeline={activeTab === "today" ? fullTimeline : []}
                      activeTab={activeTab}
                      liveUsers={liveUsers}
                      selectedCustomerPos={selectedCustomerPos}
                    // checkinPoint={selectedUserCheckin}
                    /> */}

                        <MapViewNew
                          pathLocations={
                            !showDetails
                              ? []
                              : activeTab === "today"
                                ? selectedPath
                                : activeTab === "previous"
                                  ? selectedPath
                                  : []
                          }
                          timeline={activeTab === "today" ? fullTimeline : []}
                          activeTab={activeTab}
                          selectedCustomerPos={selectedCustomerPos}

                          liveUser={
                            selectedUser
                              ? liveUsers[selectedUser.User_Id]
                              : null
                          }
                        />
                  </div>
                </div>

                {showDetails && selectedUser && (
                  <div className="map-card-overlay">
                    <CustomerCard
                      key={selectedUser?.User_Id}
                      user={selectedUser}
                      userData={locationData}
                      timeline={fullTimeline}
                      activeId={selectedCustomerId}
                      onActiveChange={(id) => setSelectedCustomerId(id)}
                      onClose={() => {
                        setShowDetails(false);
                        setSelectedUser(null);
                        setSelectedPath([]);
                        setSelectedCustomerId(null);
                        setManualLocationSelected(false);
                        setSelectedCustomerPos(null);
                      }}
                      onSelectLocation={handleSelectLocation}
                    />
                  </div>
                )}
              </div>
            )}
          </>
        )}

      </div>

    </section>
  );
}